// Boolean-test assertions per NASA Power-of-10 rule 5.
//
// Failures throw an Error so the caller's catch path takes the explicit
// recovery action. Assertions are side-effect free: only the condition is
// evaluated, and the message is built only on failure.

export function assert(cond, msg) {
  if (!cond) throw new Error(`assertion failed: ${msg}`);
}

export function assertPositiveInt(value, name) {
  if (!Number.isInteger(value) || value <= 0) {
    throw new Error(`assertion failed: ${name} must be a positive integer (got ${value})`);
  }
}
